/* ============================================
   TypeScript Types — 1Conecta ERP
   Domain models mapped from Supabase schema
   ============================================ */

// ─── Database Schema (Supabase typed client) ───

export type Database = {
  public: {
    Tables: {
      empresa: {
        Row: Empresa
        Insert: Omit<Empresa, 'id'>
        Update: Partial<Omit<Empresa, 'id'>>
      }
      servicios: {
        Row: Servicio
        Insert: Omit<Servicio, 'id'>
        Update: Partial<Omit<Servicio, 'id'>>
      }
      clientes: {
        Row: Cliente
        Insert: Omit<Cliente, 'id'>
        Update: Partial<Omit<Cliente, 'id'>>
      }
      cotizaciones: {
        Row: Cotizacion
        Insert: Omit<Cotizacion, 'id' | 'created_at' | 'public_token'>
        Update: Partial<Omit<Cotizacion, 'id' | 'created_at' | 'public_token'>>
      }
      perfiles_equipo: {
        Row: PerfilEquipo
        Insert: Omit<PerfilEquipo, 'id'>
        Update: Partial<Omit<PerfilEquipo, 'id'>>
      }
      facturas: {
        Row: Factura
        Insert: Omit<Factura, 'id' | 'created_at'>
        Update: Partial<Omit<Factura, 'id' | 'created_at'>>
      }
      config_detraccion: {
        Row: ConfigDetraccion
        Insert: Omit<ConfigDetraccion, 'id' | 'created_at'>
        Update: Partial<Omit<ConfigDetraccion, 'id' | 'created_at'>>
      }
      tipo_cambio: {
        Row: TipoCambio
        Insert: TipoCambio
        Update: Partial<TipoCambio>
      }
      proyectos: {
        Row: Proyecto
        Insert: Omit<Proyecto, 'id' | 'created_at'>
        Update: Partial<Omit<Proyecto, 'id' | 'created_at'>>
      }
      tareas: {
        Row: Tarea
        Insert: Omit<Tarea, 'id' | 'created_at'>
        Update: Partial<Omit<Tarea, 'id' | 'created_at'>>
      }
      tarea_evidencias: {
        Row: TareaEvidencia
        Insert: Omit<TareaEvidencia, 'id' | 'created_at'>
        Update: Partial<Omit<TareaEvidencia, 'id' | 'created_at'>>
      }
      config_tarifa_cliente: {
        Row: ConfigTarifaCliente
        Insert: Omit<ConfigTarifaCliente, 'id' | 'created_at'>
        Update: Partial<Omit<ConfigTarifaCliente, 'id' | 'created_at'>>
      }
      portal_accesos: {
        Row: PortalAcceso
        Insert: Omit<PortalAcceso, 'id' | 'created_at' | 'token'>
        Update: Partial<Omit<PortalAcceso, 'id' | 'created_at' | 'token'>>
      }
      factura_comprobantes: {
        Row: FacturaComprobante
        Insert: Omit<FacturaComprobante, 'id' | 'created_at'>
        Update: Partial<Omit<FacturaComprobante, 'id' | 'created_at'>>
      }
      contactos: {
        Row: Contacto
        Insert: Omit<Contacto, 'id' | 'created_at'>
        Update: Partial<Omit<Contacto, 'id' | 'created_at'>>
      }
      contacto_empresa: {
        Row: ContactoEmpresa
        Insert: Omit<ContactoEmpresa, 'id' | 'created_at'>
        Update: Partial<Omit<ContactoEmpresa, 'id' | 'created_at'>>
      }
      movimientos_caja: {
        Row: MovimientoCaja
        Insert: Omit<MovimientoCaja, 'id' | 'created_at'>
        Update: Partial<Omit<MovimientoCaja, 'id' | 'created_at'>>
      }
      pagos_programados: {
        Row: PagoProgramado
        Insert: Omit<PagoProgramado, 'id' | 'created_at'>
        Update: Partial<Omit<PagoProgramado, 'id' | 'created_at'>>
      }
      pagos_recurrentes: {
        Row: PagoRecurrente
        Insert: Omit<PagoRecurrente, 'id' | 'created_at'>
        Update: Partial<Omit<PagoRecurrente, 'id' | 'created_at'>>
      }
      centrales_costo: {
        Row: CentralCosto
        Insert: Omit<CentralCosto, 'id' | 'created_at'>
        Update: Partial<Omit<CentralCosto, 'id' | 'created_at'>>
      }
      asignaciones_central: {
        Row: AsignacionCentral
        Insert: Omit<AsignacionCentral, 'id' | 'created_at'>
        Update: Partial<Omit<AsignacionCentral, 'id' | 'created_at'>>
      }
      costos_estimados: {
        Row: CostoEstimado
        Insert: Omit<CostoEstimado, 'id' | 'created_at'>
        Update: Partial<Omit<CostoEstimado, 'id' | 'created_at'>>
      }
      gastos_proyecto: {
        Row: GastoProyecto
        Insert: Omit<GastoProyecto, 'id' | 'created_at'>
        Update: Partial<Omit<GastoProyecto, 'id' | 'created_at'>>
      }
      notificacion_templates: {
        Row: NotificacionTemplate
        Insert: Omit<NotificacionTemplate, 'id' | 'created_at'>
        Update: Partial<Omit<NotificacionTemplate, 'id' | 'created_at'>>
      }
      notificacion_log: {
        Row: NotificacionLog
        Insert: Omit<NotificacionLog, 'id'>
        Update: Partial<Omit<NotificacionLog, 'id'>>
      }
      conversaciones: {
        Row: Conversacion
        Insert: Omit<Conversacion, 'id' | 'created_at' | 'updated_at'>
        Update: Partial<Omit<Conversacion, 'id' | 'created_at' | 'updated_at'>>
      }
      mensajes: {
        Row: Mensaje
        Insert: Omit<Mensaje, 'id' | 'created_at'>
        Update: Partial<Omit<Mensaje, 'id' | 'created_at'>>
      }
      system_log: {
        Row: SystemLog
        Insert: Omit<SystemLog, 'id' | 'created_at'>
        Update: Partial<Omit<SystemLog, 'id' | 'created_at'>>
      }
      kb_articulos: {
        Row: KbArticulo
        Insert: Omit<KbArticulo, 'id' | 'created_at' | 'updated_at'>
        Update: Partial<Omit<KbArticulo, 'id' | 'created_at' | 'updated_at'>>
      }
      agente_config: {
        Row: AgentConfig
        Insert: Omit<AgentConfig, 'id' | 'created_at' | 'updated_at'>
        Update: Partial<Omit<AgentConfig, 'id' | 'created_at' | 'updated_at'>>
      }
      agente_kb_articulos: {
        Row: AgenteKbArticulo
        Insert: AgenteKbArticulo
        Update: Partial<AgenteKbArticulo>
      }
      social_strategy: {
        Row: SocialStrategy
        Insert: Omit<SocialStrategy, 'id' | 'created_at' | 'updated_at'>
        Update: Partial<Omit<SocialStrategy, 'id' | 'created_at' | 'updated_at'>>
      }
      social_posts: {
        Row: SocialPost
        Insert: Omit<SocialPost, 'id' | 'created_at' | 'updated_at'>
        Update: Partial<Omit<SocialPost, 'id' | 'created_at' | 'updated_at'>>
      }
      social_ai_conversations: {
        Row: SocialAIConversation
        Insert: Omit<SocialAIConversation, 'id' | 'created_at' | 'updated_at'>
        Update: Partial<Omit<SocialAIConversation, 'id' | 'created_at' | 'updated_at'>>
      }
      agente_memoria: {
        Row: AgenteMemoria
        Insert: Omit<AgenteMemoria, 'id' | 'created_at' | 'updated_at'>
        Update: Partial<Omit<AgenteMemoria, 'id' | 'created_at' | 'updated_at'>>
      }
    }
    Views: Record<string, never>
    Functions: Record<string, never>
    Enums: Record<string, never>
  }
}

// ─── Domain Models ───

export interface Empresa {
  id: number
  nombre: string | null
  razon_social: string | null
  ruc: string | null
  telefono: string | null
  email: string | null
  website: string | null
  ubicacion: string | null
  logo_url: string | null
  color_primario: string | null
  color_secundario: string | null
  banco: string | null
  cuenta_corriente: string | null
  cci: string | null
  cuenta_corriente_pen: string | null
  cci_pen: string | null
  swift: string | null
  direccion_banco: string | null
  // Google Workspace integration
  google_tokens: Record<string, unknown> | null
  google_connected: boolean
  // Channel visibility config: { [canal]: { visible: boolean, origins: { [channel_id]: { visible: boolean, nombre: string } } } }
  canales_config: Record<string, { visible: boolean; origins: Record<string, { visible: boolean; nombre: string }> }> | null
  firma_email_html: string | null
}

export type CategoriaServicio =
  | 'Consultoría e Implementación'
  | 'Desarrollo a Medida'
  | 'Automatización e IA'
  | 'Soporte y Acompañamiento'
  | 'Infraestructura y Hosting'
  | 'Programa de Partners'

export interface Servicio {
  id: number
  nombre: string
  descripcion: string | null
  precio_base: number
  moneda: string
  etiquetas: string[] // JSONB array — eje principal de organización
  secciones: Seccion[] // JSONB array — secciones de propuesta (cotizaciones)
  categoria: CategoriaServicio // legacy: se mantiene para cotizaciones, fuera de la UI
  incluye: string[] // JSONB array — qué incluye el servicio
  no_incluye: string[] // JSONB array — qué NO incluye el servicio
  industrias: string[] // JSONB array — industria/nicho multi-valor
  documento: string | null // Hoja-guidelines en Markdown (proceso, pasos, tablas, T&C)
  recursos?: ServicioRecurso[] // embebidos en el GET (no se persiste en la fila)
  /**
   * De quién es. `null` = catálogo de 1Conecta; con valor = del catálogo
   * propio de ese partner.
   */
  partner_id?: number | null
  /**
   * Lo deriva el servidor según quién pregunta, y de él depende que la
   * pantalla diga «tu precio» sobre un servicio del partner y «tu costo»
   * sobre uno nuestro. Confundirlos es cotizarle al cliente lo que uno paga.
   */
  es_propio?: boolean
}

export type TipoRecurso =
  | 'presentacion'
  | 'documento'
  | 'pdf'
  | 'plantilla'
  | 'enlace'
  | 'imagen'
  | 'video'

export interface ServicioRecurso {
  id: number
  // Alcance: exactamente uno de los dos (CHECK recurso_alcance_unico en la BD).
  // `categoria` = recurso de línea: una sola fila que aparece en todos los
  // servicios de esa categoría.
  servicio_id: number | null
  categoria: CategoriaServicio | null
  tipo: TipoRecurso
  titulo: string
  descripcion: string | null
  url: string
  r2_key: string | null // seteado si vive en R2
  publico: boolean
  orden: number
  created_at?: string
  updated_at?: string
}

export type TipoDocumentoFiscal = 'RUC' | 'DNI' | 'CE' | 'TAX_ID'
export type TipoEntidad = 'empresa' | 'persona'

/** Contacto vinculado a una empresa, embebido en Cliente por GET /api/clientes. */
export interface ContactoVinculado {
  id: number
  nombre: string
  apellido: string | null
  email: string | null
  telefono: string | null
  cargo: string | null
  roles: string[]
  es_principal: boolean
  cargo_empresa: string | null
}

export interface Cliente {
  id: number
  empresa: string
  tipo_entidad?: TipoEntidad | null
  ruc_dni: string | null
  direccion: string | null
  // Datos fiscales SUNAT
  tipo_documento_fiscal: TipoDocumentoFiscal
  razon_social: string | null
  direccion_fiscal: string | null
  ubigeo: string | null
  // CRM Pipeline (Sprint 0)
  pais: string | null
  es_extranjero: boolean
  origen_lead: OrigenLead | null
  etapa_pipeline: EtapaPipeline | null
  fecha_primer_contacto: string | null
  // Contactos vinculados (fuente de verdad; embebidos por el backend)
  contactos?: ContactoVinculado[]
  /**
   * El responsable comercial: de quién es esta empresa adentro del equipo.
   * Es lo único que una sesión con rol `ventas` ve de la cartera. Lo escribe
   * sólo un admin, desde la columna «Responsable» de Empresas.
   */
  responsable_id?: number | null
}

/** Alguien del equipo (admin o ventas), tal como lo devuelve `/api/auth/equipo`. */
export interface MiembroEquipo {
  id: number
  email: string
  nombre: string | null
  role: 'admin' | 'ventas'
  foto_url: string | null
}

/** Helpers de resolución de contacto desde la relación (espejo del backend). */
export function contactoFacturacionDe(cli?: Pick<Cliente, 'contactos'> | null): ContactoVinculado | null {
  const lista = cli?.contactos ?? []
  if (lista.length === 0) return null
  return lista.find(c => c.roles?.includes('FACTURACIÓN'))
    ?? lista.find(c => c.es_principal)
    ?? lista[0]
}

export type RolContacto = 'PRINCIPAL' | 'FACTURACIÓN' | 'TÉCNICO' | 'COMERCIAL' | 'GERENCIA'
export const ROLES_CONTACTO: RolContacto[] = ['PRINCIPAL', 'FACTURACIÓN', 'TÉCNICO', 'COMERCIAL', 'GERENCIA']



/** Cómo expresó el partner su markup: un %, un monto a sumar, o el precio final. */
export type MarkupTipo = 'porcentaje' | 'monto' | 'final'

/**
 * El markup del partner sobre nuestro costo. La aritmética vive en
 * `src/lib/markup.ts`; acá sólo la forma del dato que se guarda.
 */
export interface Markup {
  tipo: MarkupTipo
  /** El número que escribió, tal cual, para poder volver a mostrárselo. */
  valor: number
  /**
   * El multiplicador ya resuelto. Se guarda —en vez de recalcularse— porque
   * los precios escritos dentro del texto de una sección (`{{precio:390}}`)
   * los expande el backend al armar el PDF, y ahí no hay ítems con los que
   * reconstruir la base.
   */
  factor: number
  /** Cuándo se aplicó por última vez (ISO). */
  aplicado_at: string
}

export interface Cotizacion {
  id: number
  numero: string
  empresa_id: number
  cliente_id: number | null
  cliente_nombre: string | null
  cliente_contacto: string | null
  cliente_telefono: string | null
  cliente_ruc: string | null
  cliente_email: string | null
  fecha_emision: string | null
  validez_dias: number
  proyecto_nombre: string | null
  items: CotizacionItemsEstandar[] | CotizacionItemsEquipo | CotizacionItemsTareas // Polymorphic JSON
  subtotal: number
  igv_porcentaje: number
  igv_monto: number
  descuento_porcentaje: number
  descuento_monto: number
  total: number
  moneda: string
  estado: EstadoCotizacion
  metodos_pago: string[] // JSONB array
  /** `false` arma el documento como propuesta de ALCANCE: sin importes ni totales. */
  mostrar_precios?: boolean | null
  /** Hitos de cobro firmados con el cliente; la ficha del proyecto los lee de acá. */
  cronograma_pagos?: CuotaPago[] | null
  secciones: Seccion[] // JSONB array
  notas: string | null
  tipo_cotizacion: TipoCotizacion
  created_at: string
  public_token: string // UUID for client portal
  // Task→Standard conversion tracking
  cotizacion_origen_id: number | null
  tareas_seleccionadas: number[] | null // indices of selected tasks from parent
  pdf_url: string | null
  /**
   * El documento es un archivo subido, no el render del ERP. Las vistas que
   * muestran la cotizacion (el visor del panel, el enlace publico) sirven el
   * archivo en vez de armar el documento con `items` y `secciones`, que en una
   * cotizacion subida estan vacios.
   */
  documento_subido?: boolean | null
  branding?: CotizacionBranding | null
  /**
   * El markup del partner: cuánto le suma a NUESTRO costo para llegar al
   * precio que ve su cliente. Se guarda en vez de consumirse, porque el costo
   * base queda en `items[].costo_partner` y eso permite volver a ajustarlo —o
   * dar un descuento— partiendo siempre del costo y no del precio ya marcado.
   *
   * `null` en una cotización con ítems nuestros significa «todavía tiene
   * nuestros precios»: es lo que marca el documento como base y no apto para
   * el cliente final. Ver `src/lib/markup.ts`.
   */
  markup?: Markup | null
  /**
   * `false` = borrador interno: la armamos nosotros y el partner todavía no
   * la ve en su panel. Entre que se crea y que está lista para que él le
   * ponga su precio hay un rato de edición, y mostrarle en ese rato un
   * documento a medio hacer es peor que no mostrarle nada.
   *
   * Se libera desde la lista del admin (`PUT …/visibilidad-partner`), nunca
   * desde el editor del partner: un campo que él pudiera escribir no sería
   * una guarda.
   */
  visible_partner?: boolean | null
  lead_id?: number | null
}

/**
 * El `branding` de una cotización lleva dos cosas que conviene no confundir:
 *
 * - **Identidad** (`nombre`, `website`, `logo_url`, y el par `_2` del
 *   co-branding): es la marca blanca. Su presencia — concretamente la de
 *   `nombre` — oculta toda identidad del emisor en las tres superficies: razón
 *   social, RUC, datos bancarios y pie de página.
 * - **Presentación del precio** (`presupuesto_mas_igv`): el banner dice
 *   `USD 9,950 + IGV` en vez del total. Es independiente de la marca: una
 *   cotización propia de 1Conecta puede usarlo.
 *
 * Por eso lo que decide ocultar al emisor es `nombre`, no que el objeto exista.
 * Los logos van como **data URI**: Gotenberg no descarga recursos externos.
 */
export interface CotizacionBranding {
  nombre?: string
  website?: string
  logo_url?: string
  nombre_2?: string
  logo_url_2?: string
  presupuesto_mas_igv?: boolean
}

/**
 * Catálogo de marcas de documento (tabla `marcas`). El editor de cotizaciones
 * copia la identidad al documento; el documento guarda un snapshot, así que
 * cambiarle el logo a una marca no reescribe las propuestas ya enviadas.
 */
export interface Marca {
  id: number
  nombre: string
  website: string | null
  /** Archivo fuente en R2 — para el catálogo, no para el documento. */
  logo_url: string | null
  logo_r2_key: string | null
  /** Lo que viaja al documento (Gotenberg no baja recursos externos). */
  logo_data_uri: string | null
  activa: boolean
  notas: string | null
  created_at: string
  /**
   * De quién es la marca. `null` = de 1Conecta. Un partner solo ve las suyas
   * al cotizar; nosotros las vemos todas, porque también armamos documentos
   * con su marca.
   */
  partner_id?: number | null
}

/**
 * Los cuatro modos en que se presenta el precio. No son una columna nueva: son
 * la lectura conjunta de `mostrar_precios`, `igv_porcentaje` y
 * `branding.presupuesto_mas_igv`, que es como se usan pero no como estaban
 * puestos en el editor (tres campos sueltos).
 */
export type ModoPrecio = 'total' | 'mas_igv' | 'sin_igv' | 'sin_precios'

export interface PerfilEquipo {
  id: number
  id_perfil: string
  rol_comercial: string
  seniority: Seniority
  costo_interno_hora: number
  precio_venta_hora: number
  margen_base: number
}

// ─── Sub-types ───

export interface Seccion {
  titulo: string
  contenido: string
}

export interface CotizacionItemsEstandar {
  descripcion: string
  /** Lo que se le cobra al cliente. En una cotización de partner lo pone él. */
  precio_unitario: number
  /**
   * Lo que el partner nos debe a NOSOTROS por este ítem, cuando salió de un
   * servicio nuestro que le habilitamos. Es independiente de lo que él le
   * cobre a su cliente: puede cobrar 5.000 o nada, y nos debe lo mismo.
   *
   * Vive en el ítem y no en el catálogo porque el precio de venta cambia por
   * cliente, pero el costo no. El sanitizador lo borra antes de que la
   * cotización salga a un cliente — ver `api/src/lib/sanitize.ts`.
   */
  costo_partner?: number
  /**
   * Moneda del costo, que **no tiene por qué ser la de la venta**: el partner
   * le cobra a su cliente en soles lo que a nosotros nos paga en dólares —
   * pasa con el trato de Nordic. Sale sola del catálogo (cada servicio tiene
   * la suya) y si falta se asume la de la cotización.
   *
   * Cuando difiere de la moneda de venta **el margen no se puede calcular**:
   * restar soles menos dólares da un número que no existe. Las pantallas
   * muestran el costo y se callan el margen.
   */
  costo_partner_moneda?: string
  /**
   * Lo que este ítem le ahorra al cliente, dicho en sus términos: «Recupera
   * 22 horas al mes». Va en campo propio y no dentro de `descripcion` porque
   * las tablas escapan el HTML —y deben—, así que una negrita escrita en la
   * descripción saldría como `<strong>` literal en el PDF. Acá el dato llega
   * aparte y cada superficie lo destaca a su manera.
   *
   * Es texto libre: lo que se ahorra no siempre son horas.
   */
  ahorro?: string
  /** De qué servicio del catálogo salió, para poder auditar el costo. */
  servicio_id?: number
  /**
   * El partner retocó el precio de ESTE ítem a mano, así que el markup global
   * deja de tocarlo. Sin la marca, el siguiente ajuste general le borraría el
   * precio negociado sin avisar. Ver `src/lib/markup.ts`.
   */
  precio_fijado?: boolean
  cantidad: number
  total: number
}

export interface EquipoMiembro {
  perfil_id: number
  id_perfil: string
  rol_comercial: string
  seniority: string
  cantidad: number
  dedicacion_fte: number
  horas_custom: number | null
  horas_mensuales_linea: number
  costo_interno_hora: number
  precio_venta_hora: number
  costo_total_linea: number
  precio_venta_linea: number
}

export interface EquipoTotales {
  total_horas_equipo: number
  costo_interno_total: number
  precio_venta_sugerido: number
  precio_venta_final: number
  margen_global_proyectado: number
}

export interface CotizacionItemsEquipo {
  tipo_cotizacion: 'equipo_dedicado'
  equipo: EquipoMiembro[]
  totales: EquipoTotales
}

export interface CotizacionTareaCostos {
  sesiones_ia: number             // Sesiones IA (cada sesión = 1h Dev Fullstack)
  tarifa_dev_hora: number         // USD/h del Dev que supervisa
  horas_qa: number                // Horas de QA
  tarifa_qa_hora: number          // USD/h del QA
  tokens_input_mtok: number       // Millones de tokens input
  tokens_thinking_mtok: number    // Millones de tokens thinking (estimado)
  tokens_output_mtok: number      // Millones de tokens output
  precio_input_mtok: number       // $/MTok input (ej: 5.00)
  precio_thinking_mtok: number    // $/MTok thinking (ej: 25.00)
  precio_output_mtok: number      // $/MTok output (ej: 25.00)
}

export interface TareaArtifact {
  id: string                                       // crypto.randomUUID()
  tipo: 'archivo' | 'canvas' | 'google_doc'
  nombre: string                                   // Nombre visible
  // --- Archivo ---
  url?: string                                     // URL pública Supabase Storage
  storage_path?: string                            // Path en bucket para delete
  mime_type?: string                               // 'application/pdf', 'text/markdown', etc.
  size_bytes?: number
  // --- Canvas ---
  contenido_raw?: string                           // Texto/Markdown raw
  // --- Google Doc ---
  google_doc_id?: string                           // ID del documento Google
  google_doc_url?: string                          // URL completa para abrir
  // --- Common ---
  created_at: string
}

export interface CostoLineItem {
  id: string                         // crypto.randomUUID()
  concepto: string                   // "Sesiones IA", "QA", "Tokens Input", "Freelancer", etc.
  cantidad: number                   // horas, sesiones, MTok, unidades
  unidad: string                     // "horas", "sesiones", "MTok", "unidades"
  tarifa: number                     // $/unidad
  subtotal: number                   // cantidad × tarifa (auto-calculated)
}

export interface CotizacionTarea {
  titulo: string
  descripcion_corta: string        // Para la tabla resumen (1-2 líneas)
  contenido_detalle: string        // HTML rico para las páginas de detalle
  monto: number
  horas_estimadas: number | null   // Opcional
  entregables: string[]            // Lista de entregables
  costos?: CotizacionTareaCostos   // Desglose legacy (retrocompat con CostBreakdown)
  costos_items?: CostoLineItem[]   // Desglose dinámico de costos por línea
  artifacts?: TareaArtifact[]      // Documentos adjuntos (archivos, canvas, Google Docs)
  cronograma?: CuotaPagoTarea[]    // Cronograma propio de la tarea (sale en su hoja del PDF)
  cronograma_intro?: string        // Texto de entrada del cronograma; sin él, el PDF asume anticipo 50 % + saldo
}

// Una cuota del cronograma de una tarea. Cada pago se libera contra algo
// verificable, no contra una fecha: de ahí `condicion`.
export interface CuotaPagoTarea {
  pago: string                     // Ej: "1.ª cuota — a la firma"
  monto: number
  condicion: string                // Criterio de aceptación que libera el pago
}

export interface ConfigTarifasCotizacion {
  tarifa_dev_hora: number           // USD/h del Dev (de perfiles_equipo)
  tarifa_qa_hora: number            // USD/h del QA (de perfiles_equipo)
  precio_input_mtok: number         // $/MTok input (default 3.00)
  precio_thinking_mtok: number      // $/MTok thinking (default 12.00)
  precio_output_mtok: number        // $/MTok output (default 15.00)
  margen_global: number             // % de margen (default 60)
}

export interface CotizacionItemsTareas {
  tipo_cotizacion: 'tareas'
  tareas: CotizacionTarea[]
  config_tarifas?: ConfigTarifasCotizacion
}

// ─── Enums ───

export type TipoCotizacion = 'estandar' | 'equipo_dedicado' | 'tareas'
export type EstadoCotizacion = 'borrador' | 'enviada' | 'aceptada' | 'rechazada' | 'en_negociacion'
export type Seniority = 'Junior' | 'Semi-Senior' | 'Senior'
export type Moneda = 'USD' | 'PEN' | 'EUR'

// ─── Helper type: table names for generic CRUD ───

export type TableName = keyof Database['public']['Tables']

// ─── Facturación ───

export interface FacturaItem {
  tipo: 'fijo' | 'variable'
  descripcion: string
  precio_unitario: number
  cantidad: number
  total: number
}

export interface FacturaAdjunto {
  nombre: string
  url: string
  tipo: string
  subido_at: string
}

export interface Factura {
  id: number
  numero: string
  cliente_id: number | null
  cliente_nombre: string | null
  cliente_contacto: string | null
  cliente_ruc: string | null
  cliente_email: string | null
  proyecto_nombre: string | null
  proyecto_id: number | null
  fecha_emision: string | null
  fecha_vencimiento: string | null
  items: FacturaItem[]
  adjuntos: FacturaAdjunto[]
  subtotal: number
  igv_porcentaje: number
  igv_monto: number
  total: number
  moneda: string
  estado: EstadoFactura
  notas: string | null
  cotizacion_id: number | null
  tipo_cambio: number | null
  detraccion_aplica: boolean
  detraccion_porcentaje: number
  detraccion_monto_pen: number
  total_pen: number
  flow_token: string | null
  flow_url: string | null
  flow_status: string | null
  flow_payment_id: string | null
  fecha_pago: string | null
  nombre_interno: string | null
  pago_confirmado_cliente: boolean
  fecha_confirmacion_cliente: string | null
  // SUNAT — NubeFact electronic invoicing
  tipo_documento_sunat: TipoDocumentoSunat | null
  sunat_serie: string | null
  sunat_numero: number | null
  sunat_hash: string | null
  sunat_xml_url: string | null
  sunat_cdr_url: string | null
  sunat_pdf_url: string | null
  sunat_enlace_consulta: string | null
  sunat_error: string | null
  sunat_estado: SunatEstado | null
  created_at: string
}

export type EstadoFactura = 'pre_factura' | 'borrador' | 'emitida' | 'pagada' | 'pago_reportado' | 'anulada'
export type SunatEstado = 'no_emitida' | 'emitiendo' | 'emitida' | 'error' | 'anulada'

// ─── Configuración Detracción SPOT (tabla Supabase) ───

export interface ConfigDetraccion {
  id: number
  codigo: string
  descripcion: string
  porcentaje: number
  umbral_pen: number
  cuenta_bn: string
  leyenda: string
  activo: boolean
  created_at: string
}

/** Fallback en caso de que la tabla config_detraccion esté vacía */
export const DEFAULT_DETRACCION: Omit<ConfigDetraccion, 'id' | 'created_at'> = {
  codigo: '037',
  descripcion: 'Demás servicios gravados con el IGV',
  porcentaje: 12,
  umbral_pen: 700,
  cuenta_bn: '00051177444',
  leyenda: 'Operación sujeta al Sistema de Pago de Obligaciones Tributarias',
  activo: true,
}

// ─── Tipo de Cambio (tabla Supabase) ───

export interface TipoCambio {
  fecha: string
  compra: number
  venta: number
  created_at: string
}

// ─── Proyectos (tabla Supabase) ───

export type EstadoProyecto = 'activo' | 'pausado' | 'completado' | 'cancelado'

// Un hilo de Gmail archivado en la ficha de un proyecto. El cuerpo se guarda
// en texto plano; el original siempre queda a un clic en Gmail.
export interface MensajeCorreo {
  de: string
  para: string
  cc?: string
  fecha: string | null
  cuerpo: string
  // `Message-ID` del servidor de origen. Es lo que engancha una respuesta al
  // hilo del lado del destinatario; los hilos archivados antes de oct-2026 no
  // lo tienen hasta que se los actualiza.
  message_id?: string
  references?: string
}

export interface ProyectoCorreo {
  id: number
  gmail_thread_id: string
  asunto: string | null
  participantes: string[]
  fecha_primero: string | null
  fecha_ultimo: string | null
  cantidad: number
  adjuntos: { nombre: string; mime: string }[]
  archivado_por: string | null
  // `From` del ultimo mensaje, con nombre para mostrar. Solo en el listado:
  // `participantes` guarda direcciones sueltas y no sirve para encabezar la fila.
  de_ultimo?: string | null
  // Solo viene al pedir un hilo puntual: el listado los omite por peso.
  mensajes?: MensajeCorreo[]
  // A quienes se puede responder. Lo calcula el backend, que es el que valida
  // el envio; derivarlo aparte en el front dejaria las dos listas separarse.
  responder?: { para: string[]; cc: string[]; puede: boolean }
}

export interface HiloGmail {
  threadId: string
  asunto: string
  de: string
  fecha: string | null
  fragmento: string
  cantidad: number
  ya_archivado: boolean
}

export interface Proyecto {
  id: number
  nombre: string
  descripcion: string | null
  cliente_id: number
  servicio_id: number | null
  estado: EstadoProyecto
  fecha_inicio: string | null
  fecha_fin_estimada: string | null
  moneda: string
  presupuesto: number
  modelo_cobro: 'horas' | 'proyecto' | 'tarea'
  // Solo en contratos de soporte. Lo que el cliente compro cada mes, partido
  // por destino: pasarse en una bolsa NO se compensa con que sobre en otra.
  bolsas: BolsaHoras[] | null
  notas: string | null
  github_repo: string | null
  created_at: string
}

// Una bolsa de horas mensuales de un contrato de soporte. Las tareas se
// asignan con la etiqueta `bolsa:<clave>` y el ciclo con `ciclo:AAAA-MM`.
export interface BolsaHoras {
  clave: string
  nombre: string
  horas_mes: number
  descripcion?: string
}

// A quien se le puede escribir desde un proyecto: los contactos del cliente.
// No es una lista libre de direcciones a proposito — ver NuevoCorreoModal.
export interface DestinatarioProyecto {
  contacto_id: number
  nombre: string
  apellido: string | null
  email: string | null
  cargo: string | null
  roles: string[] | null
  es_principal: boolean | null
}

// ─── Proyecto-Cotizaciones (M:N) ───

export interface ProyectoCotizacion {
  id: number
  proyecto_id: number
  cotizacion_id: number
  created_at: string
  // Joined fields from cotizaciones
  numero?: number
  proyecto_nombre?: string
  cliente_nombre?: string
  total?: number
  estado?: string
  moneda?: string
}

// ─── Reportes de Progreso ───

export interface ReporteProgreso {
  proyecto: string
  cliente: string
  periodo: { desde: string; hasta: string }
  resumen_ai: string
  secciones: ReporteSeccion[]
  estadisticas: ReporteEstadisticas
  tareas_completadas: ReporteTarea[]
  commits_raw: ReporteCommit[]
}

export interface ReporteSeccion {
  titulo: string
  emoji: string
  items: string[]
}

export interface ReporteEstadisticas {
  total_commits: number
  total_tareas_completadas: number
  features: number
  fixes: number
  otros: number
}

export interface ReporteTarea {
  titulo: string
  estado: string
  fecha_completada: string | null
  horas_reales: number | null
}

export interface ReporteCommit {
  sha: string
  message: string
  author: string
  date: string
}

// ─── Tareas (tabla Supabase) ───

// `cancelada` es el descarte: la API del backlog no borra tareas —un DELETE
// desde un agente es irreversible y no hay papelera— asi que lo que ya no va
// se cancela y queda el rastro de por que.
/*
  Los valores guardados NO cambian, y es a propósito: los leen quince
  pantallas, los bots de WhatsApp, el backlog que consume el agente de FUTURA y
  la facturación por tareas. Renombrarlos en la base habría roto las cuatro
  cosas a la vez por un cambio de etiqueta. Lo que se lee en pantalla sale de
  `ESTADO_TAREA_META`; `nuevo` es el único valor que se sumó.
*/
export type EstadoTarea = 'nuevo' | 'pendiente' | 'en_progreso' | 'completada' | 'bloqueada' | 'cancelada'
export type PrioridadTarea = 'baja' | 'media' | 'alta' | 'urgente'
export type TipoCobro = 'sin_costo' | 'monto_fijo' | 'por_horas'
export type EstadoAprobacion = 'pendiente' | 'enviada' | 'aprobada' | 'rechazada'
export type TipoTarea = 'tarea' | 'bug' | 'mejora'

/**
 * Dependencia entre tareas: `tarea_id` no arranca hasta que termine
 * `depende_de_id`. Distinta de `parent_id`, que es la pertenencia al hito —
 * una tarea depende seguido de otra que vive en otro bloque.
 */
export interface TareaDependencia {
  tarea_id: number
  depende_de_id: number
  creado_por?: string | null
  created_at?: string
}

export const ESTADOS_TAREA: EstadoTarea[] = ['nuevo', 'pendiente', 'en_progreso', 'completada', 'bloqueada', 'cancelada']
export const PRIORIDADES_TAREA: PrioridadTarea[] = ['baja', 'media', 'alta', 'urgente']
export const TIPOS_COBRO: TipoCobro[] = ['sin_costo', 'monto_fijo', 'por_horas']
export const ESTADOS_APROBACION: EstadoAprobacion[] = ['pendiente', 'enviada', 'aprobada', 'rechazada']
export const TIPOS_TAREA: TipoTarea[] = ['tarea', 'bug', 'mejora']

export interface Tarea {
  id: number
  /** Null mientras la tarea vive en una oportunidad todavía sin proyecto. */
  proyecto_id: number | null
  /** Tarea de una oportunidad del pipeline. Ver `lead_id` en la tabla `tareas`. */
  lead_id: number | null
  titulo: string
  descripcion: string | null
  estado: EstadoTarea
  prioridad: PrioridadTarea
  tipo: TipoTarea
  /** Inicio del rango. Null = la tarea es una fecha sola (`fecha_limite`). */
  fecha_inicio: string | null
  fecha_limite: string | null
  fecha_completada: string | null
  orden: number
  etiquetas: string[]
  notas: string | null
  // v2 — Pricing & Approval
  monto: number
  horas_estimadas: number
  horas_reales: number
  tipo_cobro: TipoCobro
  estado_aprobacion: EstadoAprobacion
  factura_id: number | null
  // v3 — Backlog & Chat integration
  contacto_id: number | null
  conversacion_id: number | null
  parent_id: number | null
  origen: 'manual' | 'ai_chat' | 'ai_cron'
  followup_sugerido: string | null
  ai_confidence: number | null
  created_at: string
}

// ─── Evidencias de Tareas (tabla Supabase) ───

export interface TareaEvidencia {
  id: number
  tarea_id: number
  url: string
  nombre: string
  tipo: string
  created_at: string
}

// ─── Tarea-Mensaje Reference (M:N junction) ───

export interface TareaMensaje {
  id: number
  tarea_id: number
  mensaje_id: number
  rol: 'origen' | 'referencia' | 'evidencia'
  extracto: string | null
  created_at: string
  // Joined fields from mensajes
  contenido?: string
  tipo?: string
  media_url?: string
  media_nombre?: string
  fecha_mensaje?: string
  direccion?: string
  remitente?: string
}

// ─── Backlog task with joined contact info ───

export interface BacklogTask extends Tarea {
  contacto_nombre?: string | null
  contacto_apellido?: string | null
  contacto_telefono?: string | null
  contacto_email?: string | null
  subtasks?: Tarea[]
  mensajes?: TareaMensaje[]
  contact?: {
    id: number
    nombre: string
    apellido?: string | null
    telefono?: string | null
    email?: string | null
    cargo?: string | null
  } | null
}


// ─── Configuración Tarifa por Cliente (tabla Supabase) ───

export interface ConfigTarifaCliente {
  id: number
  cliente_id: number
  tarifa_hora: number
  umbral_horas_mes: number
  moneda: string
  created_at: string
}

// ─── Portal Accesos (tabla Supabase) ───

export interface PortalAcceso {
  id: number
  cliente_id: number
  token: string
  tipo: 'tareas' | 'cotizaciones'
  created_at: string
}

// ─── Factura Comprobantes (tabla Supabase) ───

export interface FacturaComprobante {
  id: number
  factura_id: number
  url: string
  nombre: string
  tipo: string
  subido_por: string | null
  notas: string | null
  created_at: string
}

// ─── Contactos CRM (entidad independiente M:N) ───

export interface Contacto {
  id: number
  nombre: string
  apellido: string | null
  email: string | null
  telefono: string | null
  cargo: string | null
  /** Perfil de la persona; el de la empresa vive en `Lead.linkedin_url`. */
  linkedin: string | null
  notas: string | null
  auth_user_id: string | null
  portal_activo: boolean
  onboarding_completado: boolean
  // CRM Pipeline (Sprint 0)
  estado_pipeline: string | null
  origen_lead: OrigenLead | null
  created_at: string
}

export interface ContactoEmpresa {
  id: number
  contacto_id: number
  cliente_id: number
  roles: RolContacto[]
  cargo_empresa: string | null
  es_principal: boolean
  created_at: string
}

/** Composite type for UI: Contacto + affiliated companies */
export interface ContactoConEmpresas extends Contacto {
  empresas: (ContactoEmpresa & { empresa_nombre: string })[]
}

/** Composite type for UI: Empresa + linked contacts */
export interface EmpresaConContactos extends Cliente {
  contactos_rel: (ContactoEmpresa & { contacto: Contacto })[]
}

// ─── Contabilidad: Movimientos de Caja (Flujo real) ───

export type TipoMovimiento = 'ingreso' | 'egreso'

export interface ComprobanteMovimiento {
  nombre: string
  url: string
  tipo: string
  subido_at: string
}

export type TipoComprobante = 'factura' | 'boleta' | 'recibo' | 'nota_credito' | 'otro'

export interface MovimientoCaja {
  id: number
  tipo: TipoMovimiento
  categoria: string
  // Título corto del movimiento (ej. "Multa SUNAT 6041 — IGV 06/2025").
  // La columna existe en la tabla desde siempre; faltaba en el tipo, igual que
  // en [[PagoProgramado]] y [[PagoRecurrente]].
  concepto: string | null
  descripcion: string
  monto: number // Total con IGV
  moneda: string
  fecha: string
  factura_id: number | null
  pago_programado_id: number | null
  cliente_id: number | null
  comprobantes: ComprobanteMovimiento[]
  notas: string | null
  // ─── Compliance Peruano (IGV / SUNAT) ───
  base_imponible: number | null
  igv: number | null
  serie_comprobante: string | null
  numero_comprobante: string | null
  tipo_comprobante: TipoComprobante | null
  tiene_detraccion: boolean
  porcentaje_detraccion: number | null
  monto_detraccion: number | null
  created_at: string
}

// ─── Contabilidad: Pagos Programados ───

export type EstadoPagoProgramado = 'pendiente' | 'pagado' | 'vencido' | 'reprogramado'

export interface PagoProgramado {
  id: number
  tipo: TipoMovimiento
  // `concepto` es el titulo corto que distingue el pago (ej. "Multa SUNAT —
  // IGV 06/2025"); `descripcion` es el detalle largo. Faltaba en el tipo, y
  // por eso la tabla no lo mostraba pese a existir en la BD.
  concepto: string | null
  descripcion: string
  monto: number
  moneda: string
  // La tabla tiene ambas fechas: `fecha_programada` la usa el generador de
  // recurrentes; la UI trabaja con `fecha_vencimiento`.
  fecha_programada?: string | null
  fecha_vencimiento: string
  estado: EstadoPagoProgramado
  factura_id: number | null
  cliente_id: number | null
  pago_recurrente_id: number | null
  notas: string | null
  created_at: string
}

// ─── Contabilidad: Pagos Recurrentes ───

/**
 * `quincenal` son los días 1 y 16 de cada mes — lo que significa «quincena» en
 * una planilla. «Cada 2 semanas» es `bisemanal`: no son lo mismo, y tratarlos
 * como uno corría el vencimiento un día por mes.
 * El calendario lo expande el backend (`api/src/lib/recurrencia.ts`); acá solo
 * se nombran las opciones.
 */
export type FrecuenciaPago = 'diaria' | 'semanal' | 'bisemanal' | 'quincenal' | 'mensual' | 'bimestral' | 'trimestral' | 'semestral' | 'anual'
export const FRECUENCIAS_PAGO: FrecuenciaPago[] = ['diaria', 'semanal', 'bisemanal', 'quincenal', 'mensual', 'bimestral', 'trimestral', 'semestral', 'anual']

/** Etiquetas de frecuencia, compartidas por Programados y Recurrentes. */
export const FRECUENCIA_LABEL: Record<FrecuenciaPago, string> = {
  diaria: 'Diaria',
  semanal: 'Semanal',
  bisemanal: 'Cada 2 semanas',
  quincenal: 'Quincenal (1 y 16)',
  mensual: 'Mensual',
  bimestral: 'Bimestral',
  trimestral: 'Trimestral',
  semestral: 'Semestral',
  anual: 'Anual',
}

/** Qué significa `dia_ejecucion` en cada frecuencia. */
export const USA_DIA_DEL_MES: FrecuenciaPago[] = ['mensual', 'bimestral', 'trimestral', 'semestral', 'anual']
export const USA_DIA_DE_SEMANA: FrecuenciaPago[] = ['semanal', 'bisemanal']

export const DIAS_SEMANA_ISO: { valor: number; label: string }[] = [
  { valor: 1, label: 'Lunes' },
  { valor: 2, label: 'Martes' },
  { valor: 3, label: 'Miércoles' },
  { valor: 4, label: 'Jueves' },
  { valor: 5, label: 'Viernes' },
  { valor: 6, label: 'Sábado' },
  { valor: 7, label: 'Domingo' },
]

/** Cómo termina una serie: nunca (adelanta N), en fecha, o tras N repeticiones. */
export type FinSerie = 'nunca' | 'fecha' | 'repeticiones'

/** Lo que la UI manda para crear o previsualizar una serie. */
export interface SeriePago {
  frecuencia: FrecuenciaPago
  fecha_inicio: string
  dia_ejecucion?: number | null
  fecha_fin?: string | null
  repeticiones?: number | null
}

/** Alcance de un borrado sobre una serie de pagos. */
export type AlcanceEliminacion = 'uno' | 'siguientes' | 'serie'

export interface PagoRecurrente {
  id: number
  tipo: TipoMovimiento
  // `concepto` es NOT NULL en la tabla y es el titulo corto que identifica el
  // gasto (ej. "Anthropic, PBC — Max plan"); `descripcion` es el detalle.
  // Faltaba en el tipo, igual que en [[PagoProgramado]].
  concepto: string | null
  descripcion: string
  monto: number
  moneda: string
  frecuencia: FrecuenciaPago
  /**
   * Mensuales y más largas: día del mes (1-31; cae en el último si el mes no lo
   * tiene). Semanal y bisemanal: día ISO (1 = lunes). Estaba poblado en la base
   * (30, 20, 13…) sin que nada lo leyera: el generador sumaba días fijos.
   */
  dia_ejecucion: number | null
  fecha_inicio: string
  fecha_fin: string | null
  activo: boolean
  cliente_id: number | null
  notas: string | null
  created_at: string
}

// ── Pipeline & CRM ─────────────────────────
/**
 * `prospecto` es la etapa previa a `lead`: outbound que todavía no se contactó.
 * No entra al Kanban — se trabaja en su propia lista (ver Épica 9 del PRD).
 */
export type EtapaPipeline = 'prospecto' | 'lead' | 'contactado' | 'diagnostico' | 'cotizado' | 'negociacion' | 'cerrado'

/** Cómo terminó una oportunidad cerrada. Null mientras sigue abierta. */
export type ResultadoLead = 'ganado' | 'perdido'

/**
 * Un paso dentro de una etapa core, de la lista que configura cada partner.
 *
 * Las seis etapas son del sistema —el cotizador, los bots y los reportes
 * actúan sobre ellas—; esto es lo que cada quien monta encima para trabajar
 * con sus propios pasos sin que el esqueleto cambie.
 */
export interface PipelineSubestado {
  id: number
  /** Null = los de 1Conecta. */
  partner_id: number | null
  etapa: EtapaPipeline
  nombre: string
  /**
   * El NOMBRE del token (`cat-1`…`cat-8`), nunca un hex: cada token tiene su
   * valor en el tema claro y en el oscuro. Null = hereda el de su etapa.
   */
  color?: string | null
  orden: number
  activo: boolean
}

export type TipoCampo = 'texto' | 'numero' | 'moneda' | 'fecha' | 'lista' | 'booleano'

/**
 * La definición de un campo que un partner agregó a la ficha. El valor vive
 * en `Lead.campos`, bajo esta misma `clave`.
 */
export interface CampoDefinicion {
  id: number
  partner_id: number | null
  entidad: 'lead'
  /** Llave del jsonb. No se edita después del alta. */
  clave: string
  etiqueta: string
  tipo: TipoCampo
  /** Sólo para `tipo: 'lista'`. */
  opciones: string[] | null
  orden: number
  activo: boolean
}

export type PrioridadProspecto = 'A' | 'B' | 'C'
export type OrigenLead = 'meta_ads' | 'web' | 'referido' | 'workana' | 'radio_tv' | 'chatbot' | 'booking' | 'whatsapp' | 'campana_email' | 'outbound' | 'otro'

// ── Lead = Oportunidad (Pipeline) ──────────────
export interface FormularioItem {
  pregunta: string
  respuesta: string | string[]
  tipo?: string
}

export interface LeadContacto {
  id: number
  contacto_id: number
  es_principal: boolean
  linkedin: string | null
  /** Roles dentro de la oportunidad. Mismo catálogo que `contacto_empresa.roles`. */
  roles: RolContacto[]
  /** Legado: texto suelto anterior a `roles[]`. No se edita desde la UI. */
  rol: string
  nombre: string
  apellido: string | null
  email: string | null
  telefono: string | null
  cargo: string | null
}

export interface Lead {
  id: number
  codigo: string
  titulo: string | null
  empresa: string | null
  etapa: EtapaPipeline
  /**
   * Cómo terminó: `ganado`, `perdido`, o null mientras sigue abierta.
   *
   * Es independiente de `etapa` a propósito: la etapa dice dónde está en el
   * embudo y el resultado qué pasó al final. Un lead en `cerrado` sin
   * resultado es uno que se movió antes de que existiera esta columna.
   */
  resultado?: ResultadoLead | null
  motivo_perdida?: string | null
  cerrado_at?: string | null
  /** El paso dentro de la etapa. Se limpia al cambiar de etapa. */
  subestado?: string | null
  /** Valores de los campos a medida, por `CampoDefinicion.clave`. */
  campos?: Record<string, string | number | boolean | null>
  origen: OrigenLead
  es_agencia: boolean
  formulario_id: string | null
  formulario_datos: FormularioItem[]
  utm_source: string | null
  utm_medium: string | null
  utm_campaign: string | null
  referrer_url: string | null
  cliente_id: number | null
  notas: string | null
  /** Cuándo el partner nos pidió la cotización. Null = no la pidió. */
  cotizacion_solicitada_at?: string | null
  /**
   * Servicio del catálogo que se le está ofreciendo. De acá sale el material
   * comercial que muestra la ficha (`Servicio.recursos`).
   */
  servicio_id: number | null
  // Prospección outbound
  ciudad: string | null
  /** Qué se vio que indica necesidad. Es el criterio con el que se prioriza. */
  senal_dolor: string | null
  /**
   * Texto libre, respaldo de `servicio_id`: lo escribe el importador de planillas
   * del SDR y sirve para lo que el lead pide y todavía no está en catálogo.
   */
  servicio_interes: string | null
  prioridad: PrioridadProspecto | null
  /** LinkedIn de la empresa; el de la persona vive en el contacto. */
  linkedin_url: string | null
  web_url: string | null
  // Comercial — `valor_estimado` viaja como string (NUMERIC de Postgres)
  valor_estimado: string | null
  moneda: MonedaLead | null
  probabilidad: number | null
  fecha_cierre_estimada: string | null
  industria: string | null
  fecha_primer_contacto: string | null
  created_at: string
  updated_at: string
  contactos: LeadContacto[]
  proyecto_id: number | null
  /**
   * Quién la trabaja. `null` = todavía nadie: es la bandeja de lo que entra
   * solo (formulario de la web, booking, chatbot), que cualquiera de ventas
   * puede ver y tomar. Al revés que `clientes.responsable_id`, donde sin
   * responsable la empresa no la ve nadie de ventas.
   */
  responsable_id?: number | null
  /**
   * De qué partner es la oportunidad. `null` = nuestra. Junto con
   * `cotizacion_solicitada_at` decide el sello de traspaso de la tarjeta: una
   * oportunidad de partner sólo entra a nuestro tablero si nos la pasaron
   * para cotizar.
   */
  partner_id?: number | null
}

export type MonedaLead = 'PEN' | 'USD'

/** Documento adjunto a una oportunidad, o a una de sus tareas. */
export interface LeadAdjunto {
  id: number
  lead_id: number
  tarea_id: number | null
  nombre: string
  tipo: string
  mime: string | null
  size_bytes: number | null
  r2_key: string
  url: string
  subido_por: string | null
  created_at: string
}

// ── Centrales de Costo ─────────────────────
export interface CentralCosto {
  id: number
  nombre: string
  codigo: string
  porcentaje: number
  descripcion: string | null
  activa: boolean
  orden: number
  created_at: string
}

export interface AsignacionCentral {
  id: number
  cotizacion_id: number
  central_id: number
  porcentaje: number
  monto: number
  moneda: string
  created_at: string
}

// ── Costos Estimados & Gastos ──────────────
export type CategoriaCosto = 'freelance' | 'herramienta' | 'licencia' | 'infraestructura' | 'otro'

export interface CostoEstimado {
  id: number
  cotizacion_id: number
  descripcion: string
  monto: number
  moneda: string
  categoria: CategoriaCosto
  created_at: string
}

export interface GastoProyecto {
  id: number
  proyecto_id: number
  costo_estimado_id: number | null
  descripcion: string
  monto: number
  moneda: string
  tipo: string
  comprobante_url: string | null
  fecha: string
  created_at: string
}

// ── Cronograma de Pagos ────────────────────
export interface CuotaPago {
  numero: number
  descripcion: string
  porcentaje: number
  monto: number
  condicion: string
}

// ── Notificaciones ─────────────────────────
export type CanalNotificacion = 'email' | 'whatsapp'
export type EstadoNotificacion = 'enviado' | 'fallido' | 'leido'

export interface NotificacionTemplate {
  id: number
  evento: string
  canal: CanalNotificacion
  destinatario_rol: string
  asunto: string | null
  template_texto: string
  template_html: string | null
  variables: string[]
  activo: boolean
  created_at: string
}

export interface NotificacionLog {
  id: number
  template_id: number | null
  evento: string
  canal: CanalNotificacion
  contacto_id: number | null
  empresa_id: number | null
  estado: EstadoNotificacion
  metadata: Record<string, unknown>
  error: string | null
  enviado_at: string
}

// ── SUNAT ──────────────────────────────────
export type TipoDocumentoSunat = '01' | '02' | '03' | '07' | '08'
// 01 = Factura, 02 = Factura Exportación, 03 = Boleta, 07 = Nota Crédito, 08 = Nota Débito

// ─── Chat / Inbox Omnicanal ───
export type CanalChat = 'whatsapp' | 'instagram' | 'email' | 'web_chat' | 'sms' | 'portal'
export type DireccionMensaje = 'entrante' | 'saliente'
export type TipoMensaje = 'texto' | 'imagen' | 'audio' | 'video' | 'documento' | 'sticker' | 'ubicacion'
export type EstadoEntrega = 'pendiente' | 'enviado' | 'entregado' | 'leido' | 'error'
export type MediaStatus = 'ok' | 'downloading' | 'upload_failed' | 'download_failed' | 'expired'
/** `omitida` = fuera de los topes de tamaño/duración, o el audio no tenía habla. */
export type TranscripcionStatus = 'pendiente' | 'ok' | 'fallida' | 'omitida'
/**
 * Qué pide un mensaje entrante. El enum sale de un barrido de los 2.877 mensajes
 * reales de WhatsApp, no de un catálogo genérico: `operacion` existe porque hay
 * chats que son puro día a día del cliente (rutas, despachos), y `ruido` porque
 * Entel, Facebook y Wazzup escriben solos.
 */
export type IntencionMensaje =
  | 'pedido'          // pide algo nuevo: una función, una web, un cambio
  | 'bug'             // reporta algo roto
  | 'estado'          // pregunta por el avance de algo ya pedido
  | 'comercial'       // precio, cotización, propuesta
  | 'administrativo'  // pago, factura, acceso, credenciales
  | 'operacion'       // día a día del cliente
  | 'social'          // saludo, agradecimiento, charla
  | 'ruido'           // promoción, código de verificación, automático
/** `omitida` = sin texto que clasificar, o descartado por el prefiltro de ruido. */
export type IntencionStatus = 'pendiente' | 'ok' | 'fallida' | 'omitida'
/** Las intenciones que piden una acción del equipo: las que llenan la bandeja. */
export const INTENCIONES_ACCIONABLES: IntencionMensaje[] = [
  'pedido', 'bug', 'estado', 'comercial', 'administrativo',
]
export type EstadoConversacion = 'abierta' | 'cerrada' | 'archivada'
export type TipoLog = 'success' | 'error' | 'warning' | 'info'

export interface Conversacion {
  id: number
  canal: CanalChat
  chat_id: string
  channel_id: string | null
  contacto_id: number | null
  /** @deprecated Sin FK ni uso. Usar `cliente_id`. */
  empresa_id: number | null
  /** Empresa dueña del chat. Es el vínculo de un grupo, que no tiene contacto único. */
  cliente_id: number | null
  /** Proyecto por defecto: las tareas extraídas del hilo lo heredan. */
  proyecto_id: number | null
  estado: EstadoConversacion
  ultimo_mensaje: string | null
  ultimo_mensaje_at: string | null
  mensajes_no_leidos: number
  metadata: Record<string, unknown>
  created_at: string
  updated_at: string
}

export interface ReplyPreview {
  contenido: string | null
  tipo: TipoMensaje
  direccion: DireccionMensaje
}

export interface Mensaje {
  id: number
  conversacion_id: number
  direccion: DireccionMensaje
  remitente: string | null
  tipo: TipoMensaje
  contenido: string | null
  media_url: string | null
  media_mime: string | null
  media_nombre: string | null
  media_size: number | null
  media_duracion: number | null
  media_status: MediaStatus
  /**
   * Nota de voz pasada a texto con IA. Vive aparte de `contenido` a propósito: una
   * cosa es lo que el contacto escribió y otra lo que dijo — y lo que la IA entendió
   * que dijo. Solo se llena en mensajes de audio.
   */
  transcripcion: string | null
  transcripcion_status: TranscripcionStatus | null
  /**
   * Qué pide el mensaje, puesto por el triador. Se llena solo en entrantes con texto
   * (o con transcripción): una imagen sin pie queda `omitida`.
   */
  intencion: IntencionMensaje | null
  intencion_status: IntencionStatus | null
  intencion_confianza: number | null
  wazzup_message_id: string | null
  estado_entrega: EstadoEntrega
  error: string | null
  fecha_mensaje: string
  created_at: string
  reply_to_id: number | null
  reply_preview: ReplyPreview | null
  /**
   * Marcas que deja el webhook de Wazzup:
   * `echo` — se envió fuera del ERP (celular o chat nativo de Wazzup);
   * `editado` / `eliminado` — el autor lo cambió o lo borró en el messenger.
   */
  metadata?: Record<string, unknown> | null
}

// ─── Mensajes Programados ───
export type EstadoProgramado = 'pendiente' | 'enviando' | 'enviado' | 'fallido' | 'cancelado'

/** Un archivo colgado de una nota. Vive en el jsonb de la nota, no en tabla aparte. */
export interface NotaAdjunto {
  nombre: string
  mime: string
  size_bytes: number
  url: string
  /** NULL = adjunto por enlace externo, que no tiene nada que borrar en R2. */
  r2_key: string | null
}

/**
 * Nota interna dentro de una conversacion. No es un mensaje: no se envia nunca, no cuenta
 * como no leido y ningun bot la lee. Por eso vive en su propia tabla.
 */
export interface ConversacionNota {
  id: number
  conversacion_id: number
  /** Posicion en la linea de tiempo del chat. Editable: una nota se antedata. */
  fecha: string
  contenido: string
  autor_id: number | null
  autor_nombre?: string | null
  adjuntos: NotaAdjunto[]
  created_at: string
  updated_at: string
}

export interface MensajeProgramado {
  id: number
  conversacion_id: number
  contenido: string | null
  fecha_programada: string
  scheduled_at: string
  estado: EstadoProgramado
  enviado_at: string | null
  created_at: string
  updated_at: string
}

export interface SystemLog {
  id: number
  tipo: TipoLog
  accion: string
  descripcion: string
  tags: string[]
  metadata: Record<string, unknown>
  error: string | null
  entidad_tipo: string | null
  entidad_id: number | null
  ip: string | null
  created_at: string
}

// ─── Knowledge Base (Valentina AI) ───

export type CategoriaKb = 'servicios' | 'metodologia' | 'casos_exito' | 'faq' | 'empresa' | 'precios' | 'general'
export const CATEGORIAS_KB: CategoriaKb[] = ['servicios', 'metodologia', 'casos_exito', 'faq', 'empresa', 'precios', 'general']

export interface KbArticulo {
  id: number
  titulo: string
  categoria: CategoriaKb
  contenido_md: string
  resumen: string | null
  archivo_original_url: string | null
  archivo_nombre: string | null
  tags: string[]
  activo: boolean
  orden: number
  tokens_estimados: number | null
  created_at: string
  updated_at: string
}

// ─── Agente Config (Valentina AI) ───

export type TipoRegla = 'prohibido' | 'obligatorio' | 'limitacion'

export interface ReglaConversacion {
  tipo: TipoRegla
  descripcion: string
  activo: boolean
}

export interface ScriptFase {
  id: string
  nombre: string
  objetivo: string
  instrucciones: string
}

export interface ScriptVentas {
  fases: ScriptFase[]
}

export interface AgentConfig {
  id: number
  nombre: string
  slug: string
  rol: string
  modelo: string
  temperature: number
  max_tokens: number
  system_prompt: string
  reglas_conversacion: ReglaConversacion[]
  avatar_url: string | null
  activo: boolean
  horario_atencion: Record<string, string> | null
  mensaje_fuera_horario: string | null
  mensaje_bienvenida: string | null
  calendly_url: string | null
  script_ventas: ScriptVentas | null
  metadata: Record<string, unknown>
  created_at: string
  updated_at: string
}

export interface AgenteKbArticulo {
  agente_id: number
  articulo_id: number
}

export type TipoMemoria = 'preferencia' | 'patron' | 'feedback' | 'voz_marca' | 'aprendizaje'

export interface AgenteMemoria {
  id: number
  agente_id: number
  tipo: TipoMemoria
  contenido: string
  fuente: string | null
  relevancia: number
  metadata: Record<string, unknown>
  activo: boolean
  created_at: string
  updated_at: string
}

// ============= SOCIAL MEDIA MODULE =============

export type SocialChannel = 'instagram' | 'facebook' | 'twitter' | 'pinterest'
export type SocialPostStatus = 'proposal' | 'draft' | 'pending_review' | 'approved' | 'scheduled' | 'published' | 'rejected' | 'error'
export type SocialPostType = 'image' | 'video' | 'carousel' | 'text' | 'reel' | 'story'
export type AIConversationContext = 'content' | 'strategy' | 'analysis'

export const SOCIAL_CHANNELS: SocialChannel[] = ['instagram', 'facebook', 'twitter', 'pinterest']
export const SOCIAL_POST_STATUSES: SocialPostStatus[] = ['proposal', 'draft', 'pending_review', 'approved', 'scheduled', 'published', 'rejected', 'error']
export const SOCIAL_POST_TYPES: SocialPostType[] = ['image', 'video', 'carousel', 'text', 'reel', 'story']

export interface ContentPillar {
  name: string
  description: string
  percentage: number
}

export interface PostingSlot {
  channel: SocialChannel
  days: number[]   // 0=Mon..6=Sun
  hours: number[]  // 0-23
}

export interface HashtagGroup {
  name: string
  tags: string[]
}

export interface SocialStrategy {
  id: number
  brand_voice: string | null
  target_audience: string | null
  content_pillars: ContentPillar[]
  posting_schedule: PostingSlot[]
  hashtag_groups: HashtagGroup[]
  visual_style: string | null
  competitors: string[]
  guidelines: string | null
  created_at: string
  updated_at: string
}

export interface SocialPost {
  id: number
  metricool_post_id: number | null
  metricool_uuid: string | null
  status: SocialPostStatus
  publication_date: string | null
  channels: SocialChannel[]
  caption: string
  hashtags: string[]
  media_urls: string[]
  media_alt_texts: string[]
  post_type: SocialPostType
  instagram_data: Record<string, unknown> | null
  facebook_data: Record<string, unknown> | null
  twitter_data: Record<string, unknown> | null
  pinterest_data: Record<string, unknown> | null
  ai_generated: boolean
  ai_prompt: string | null
  ai_conversation_id: number | null
  analytics: SocialPostAnalytics | null
  notes: string | null
  image_prompt: string | null
  created_at: string
  updated_at: string
}

export interface SocialPostAnalytics {
  reach: number
  impressions: number
  engagement: number
  likes: number
  comments: number
  shares: number
  saves: number
}

export interface AIMessage {
  role: 'user' | 'assistant' | 'system'
  content: string
  timestamp: string
  metadata?: {
    generated_post_id?: number
    generated_image_url?: string
    action?: string
  }
}

export interface SocialAIConversation {
  id: number
  title: string
  context: AIConversationContext
  messages: AIMessage[]
  generated_posts: number[]
  created_at: string
  updated_at: string
}

// ============= MARCO CHAT (Admin) =============

/** Maps to `conversaciones` table filtered by agent_slug='marco' + user_id */
export interface MarcoConversation {
  id: number
  chat_id: string
  estado: 'abierta' | 'cerrada' | 'archivada'
  ultimo_mensaje: string | null
  ultimo_mensaje_at: string | null
  agent_slug: string | null
  created_at: string
  metadata: Record<string, unknown>
}

/** Maps to `mensajes` table */
export interface MarcoMessage {
  id: number
  conversacion_id: number
  direccion: 'entrante' | 'saliente'
  contenido: string | null
  fecha_mensaje: string
}

// ============= WIKI / MAPRO MODULE =============

export type EstadoWikiArticulo = 'borrador' | 'publicado' | 'archivado'

export interface WikiCategoria {
  id: string
  nombre: string
  slug: string
  descripcion: string | null
  icono: string | null
  orden: number
  color: string | null
  parent_id: string | null
  created_at: string
  updated_at: string
  // Computed
  articulos_count?: number
  articulos?: WikiArticulo[]
}

export interface WikiArticulo {
  id: string
  categoria_id: string
  titulo: string
  slug: string
  contenido: string
  resumen: string | null
  icono: string | null
  orden: number
  estado: EstadoWikiArticulo
  autor_id: string | null
  metadata: Record<string, unknown>
  created_at: string
  updated_at: string
  // Computed (join)
  categoria?: WikiCategoria
}

export interface WikiAnotacion {
  id: string
  articulo_id: string
  user_id: string
  texto_seleccionado: string
  selector_start: string
  offset_start: number
  selector_end: string
  offset_end: number
  nota: string | null
  color: string
  created_at: string
  updated_at: string
}

export interface WikiComentario {
  id: string
  articulo_id: string
  anotacion_id: string | null
  user_id: string
  contenido: string
  parent_id: string | null
  created_at: string
  updated_at: string
}

export interface WikiVersion {
  id: string
  articulo_id: string
  contenido_anterior: string
  contenido_nuevo: string
  user_id: string
  created_at: string
}

// ─── Marketing: Email Campaigns ───

export interface CampanaEmail {
  id: number
  nombre: string
  codigo: string
  asunto: string
  contenido_html: string
  estado: 'borrador' | 'activa' | 'pausada' | 'completada'
  envios_diarios: number
  hora_envio: string
  whatsapp_numero: string
  whatsapp_mensaje: string
  booking_url: string
  total_prospectos: number
  total_enviados: number
  total_abiertos: number
  total_clicks: number
  total_leads: number
  created_at: string
  updated_at: string
}

export interface CampanaProspecto {
  id: number
  campana_id: number
  email: string
  nombre: string | null
  empresa: string | null
  cargo: string | null
  telefono: string | null
  estado: 'pendiente' | 'enviado' | 'abierto' | 'click' | 'respondido' | 'rebotado'
  enviado_at: string | null
  abierto_at: string | null
  click_at: string | null
  respondido_at: string | null
  tracking_code: string
  resend_id: string | null
  contacto_id: number | null
  metadata: Record<string, unknown>
  created_at: string
}

export interface CampanaEvento {
  id: number
  prospecto_id: number
  campana_id: number
  tipo: 'enviado' | 'abierto' | 'click_whatsapp' | 'click_calendly' | 'lead_whatsapp' | 'lead_calendly' | 'rebotado'
  metadata: Record<string, unknown>
  created_at: string
}

export interface NewsletterSuscriptor {
  id: number
  email: string
  nombre: string | null
  origen: 'blog' | 'landing' | 'manual' | 'import' | string
  fuente_url: string | null
  interes: string | null
  estado: 'activo' | 'baja'
  confirmado: boolean
  token_baja: string | null
  ip: string | null
  user_agent: string | null
  created_at: string
  updated_at: string
}

// ─── Marketing: Blog CMS (Git-based) ───

export type BlogProductKey =
  | 'hosting' | 'monday' | 'consultoria' | 'desarrollo' | 'soporte'
  | 'workspace' | 'cloudflare' | 'servidores' | 'leadforge'

export interface BlogFaqItem {
  q: string
  a: string
}

// Frontmatter completo del .md (contrato con 1conectaweb)
export interface BlogFrontmatter {
  title: string
  description: string
  date: string // YYYY-MM-DD
  author: string
  authorAvatar: string | null
  cover: string | null
  tags: string[]
  draft: boolean
  featured: boolean
  relatedProduct: BlogProductKey | string | null
  keyTakeaways: string[]
  faq: BlogFaqItem[]
}

// Artículo completo (respuesta de GET /api/blog/:slug)
export interface BlogArticle {
  slug: string
  sha: string
  frontmatter: BlogFrontmatter
  body: string
}

// Fila del listado (respuesta de GET /api/blog)
export interface BlogArticleListItem {
  slug: string
  sha: string
  title: string
  date: string
  draft: boolean
  featured: boolean
  cover: string | null
  tags: string[]
  relatedProduct: BlogProductKey | string | null
}

// ─── Marketing: Booking (Agendamiento) ───

export interface DisponibilidadConfig {
  id: number
  nombre: string
  duracion_minutos: number
  dias_disponibles: number[]
  hora_inicio: string
  hora_fin: string
  buffer_minutos: number
  max_dias_adelanto: number
  timezone: string
  activo: boolean
  created_at: string
}

export interface Agendamiento {
  id: number
  config_id: number | null
  fecha: string
  hora_inicio: string
  hora_fin: string
  nombre: string
  email: string
  telefono: string | null
  empresa: string | null
  notas: string | null
  tracking_code: string | null
  campana_id: number | null
  prospecto_id: number | null
  origen: 'directo' | 'campana_email' | 'chatbot' | 'social'
  google_event_id: string | null
  google_meet_url: string | null
  contacto_id: number | null
  estado: 'confirmado' | 'cancelado' | 'completado' | 'no_show'
  created_at: string
}

export interface Feriado {
  id: number
  fecha: string
  nombre: string
  recurrente: boolean
  activo: boolean
  created_at: string
}

// ─── Chat Artifacts ───
export interface ChatArtifact {
  id: number
  conversacion_id: number
  tipo: 'strategy' | 'calendar' | 'brief'
  titulo: string
  contenido: {
    voz_marca?: string
    audiencia_objetivo?: string
    pilares_contenido?: string[]
    hashtags?: string[]
    estilo_visual?: string
    [key: string]: any
  }
  version: number
  estado: 'draft' | 'approved' | 'applied'
  created_at?: string
  updated_at?: string
}

// ─── Hosting ───

export type HostingEstado = 'pendiente' | 'pagado' | 'activo' | 'suspendido' | 'cancelado' | 'expirado'
export type HostingProvisioningEstado = 'pendiente' | 'en_progreso' | 'completado' | 'error'
export type DominioTipo = 'existente' | 'nuevo' | 'sin_dominio'
// Proveedor del backend del servicio gestionado. El corte de acceso lo hace el borde de
// Cloudflare; esto decide el adaptador secundario (WHM suspend / docker stop / pausa Supabase).
export type HostingProveedor = 'verpex_whm' | 'hetzner_docker' | 'cloudflare_edge' | 'supabase_project'
export type HostingSuspensionModo = 'auto' | 'manual'
// Componente del stack de un cliente: front de borde (Cloudflare), backend (Hetzner/Supabase), etc.
// Cada componente tiene su propio proveedor; el paquete (HostingPedido) los agrupa como unidad de cobro.
export type HostingKillMode = 'whm_suspend' | 'docker_stop' | 'supabase_pause' | 'kv_gate' | 'manual'
export interface HostingComponente {
  tipo?: 'edge' | 'backend' | 'db' | 'otro' | string
  proveedor?: string
  recurso_ref?: string   // hostname CF / nombre de contenedor Docker / project_ref de Supabase / usuario cPanel
  kill_mode?: HostingKillMode | string
}
// Tipo de paquete = unidad de cobro/ciclo de vida (lo que el cliente compra y se cancela atómicamente).
export type HostingTipoPaquete = 'hosting' | 'cloud' | 'otro'

export interface HostingPedido {
  id: number
  codigo: string
  /** Llave con la que el cliente abre sus rutas públicas (estado, comprobante, pago). */
  public_token: string | null
  plan_id: string
  plan_nombre: string
  periodo: 'mensual' | 'anual'
  moneda: 'PEN' | 'USD'
  precio_mensual: number
  total: number
  nombre: string
  email: string
  whatsapp: string
  ruc: string | null
  metodo_pago: 'mercadopago' | 'transferencia'
  estado: HostingEstado
  estado_provisioning: HostingProvisioningEstado | null
  mp_preference_id: string | null
  mp_checkout_url: string | null
  mp_payment_id: string | null
  dominio_cobro: number | null
  comprobante_url: string | null
  notas: string | null
  fecha_pago: string | null
  dominio: string | null
  cpanel_url: string | null
  cpanel_usuario: string | null
  ip_servidor: string | null
  fecha_vencimiento: string | null
  fecha_corte: string | null   // fecha de corte programada (= vencimiento + gracia); editable
  proveedor: HostingProveedor  // derivado/legacy: solo para badge/filtro; el corte lo deciden los componentes
  componentes: HostingComponente[]
  suspension_modo: HostingSuspensionModo
  tipo_paquete: HostingTipoPaquete
  renovacion_auto: boolean
  proyecto_id: number | null
  cliente_id: number | null
  reminder_flags: Record<string, string>
  origen: 'checkout' | 'manual' | 'sync_whm'
  whm_plan_original: string | null
  whm_last_sync_at: string | null
  whm_sync_status: 'synced' | 'orphan' | 'mismatch' | null
  es_sistema: boolean  // cuenta de infra (reseller raíz / host de proxies): oculta y protegida
  backup_status: 'generating' | 'generating_delete' | 'ready' | 'error' | null
  backup_r2_key: string | null
  backup_url: string | null
  backup_size: number | null
  backup_requested_at: string | null
  backup_completed_at: string | null
  backup_token: string | null
  created_at: string
  updated_at: string
  dominios?: HostingDominio[]
}

export interface WHMSyncPreview {
  in_whm: number
  in_erp: number
  to_import: WHMAccountPreview[]
  to_update: WHMStatusMismatch[]
}

export interface WHMAccountPreview {
  user: string
  domain: string
  plan: string
  plan_mapped: string | null
  suspended: boolean
  email: string
}

export interface WHMStatusMismatch {
  user: string
  domain: string
  whm_suspended: boolean
  erp_estado: string
  erp_id: number
}

export interface HostingDominio {
  id: number
  pedido_id: number | null
  dominio: string
  tipo: DominioTipo
  registrador: string | null
  estado: string
  fecha_registro: string | null
  fecha_vencimiento: string | null
  dns_configurado: boolean
  notas: string | null
  created_at: string
}

export interface WHMServerStats {
  total_accounts: number
  active: number
  suspended: number
  accounts: {
    user: string
    domain: string
    plan: string
    diskused: string
    disklimit: string
    suspended: boolean
  }[]
}

// ─── Asistente de Contabilidad ───

export interface AsistenteSesion {
  id: number
  usuario_id: number | null
  titulo: string | null
  estado: 'activa' | 'archivada'
  created_at: string
  updated_at: string
  no_leidos?: number
}

export interface AsistenteMensaje {
  id: number
  sesion_id: number
  rol: 'user' | 'assistant' | 'system'
  contenido: string | null
  adjuntos: { nombre: string; url: string; tipo: string }[]
  propuestas: unknown
  leido: boolean
  created_at: string
}

// ─── Apps (Plataforma de Micro-Productos IA) ───

export type EstadoApp = 'produccion' | 'proximamente' | 'por_desplegar' | 'pausada' | 'deprecada'

/** Tarifa de un modelo específico (p. ej. gemini-2.5-flash = 2 créditos / 1k tokens) */
export interface TarifaModelo {
  modelo: string
  creditos: number
  unidad: string
}

/** Modelo de cobro flexible por app (por documento, por token, por modelo, etc.) */
export interface ModeloCobro {
  tipo?: 'por_documento' | 'por_token' | 'por_modelo' | 'suscripcion' | 'otro'
  creditos?: number
  unidad?: string
  descripcion?: string
  tarifas?: TarifaModelo[]
}

/** App del catálogo de la plataforma de micro-productos IA (tabla `apps_catalogo`) */
export interface AppCatalogo {
  id: number
  slug: string
  nombre: string
  descripcion: string | null
  descripcion_larga: string | null
  endpoint: string | null
  icono_url: string | null
  modelo_cobro: ModeloCobro
  etiquetas: string[]
  estado: EstadoApp
  orden: number
  created_at?: string
  updated_at?: string
}

export type EstadoActivacion = 'pendiente' | 'activada' | 'revocada'

/** Activación de una app para un cliente = su derecho de acceso (tabla `app_activaciones`) */
export interface AppActivacion {
  id: string
  cliente_id: number
  cliente_nombre?: string | null
  app_slug: string
  asientos: number
  estado: EstadoActivacion
  codigo: string
  codigo_usado: boolean
  codigo_expira_at: string
  activada_en: string | null
  created_at?: string
}

/** Fila de "vitrina" en el portal (app en producción, sin datos internos) */
export interface AppDisponible {
  slug: string
  nombre: string
  descripcion: string | null
  descripcion_larga: string | null
  endpoint: string | null
  icono_url: string | null
  modelo_cobro: ModeloCobro
  etiquetas: string[]
}

/** Activación tal como la ve el cliente en el portal (app embebida) */
export interface MiApp {
  id: string
  app_slug: string
  asientos: number
  estado: EstadoActivacion
  codigo: string
  codigo_usado: boolean
  codigo_expira_at: string
  activada_en: string | null
  nombre: string | null
  descripcion: string | null
  endpoint: string | null
  icono_url: string | null
  modelo_cobro: ModeloCobro | null
}

/** Respuesta de GET /api/portal/apps */
export interface PortalAppsResponse {
  disponibles: AppDisponible[]
  mis_apps: MiApp[]
}

// ─── Expedientes SUNAT ───
// Trámites tributarios con estado y plazo (esquelas, cartas de descargo,
// resoluciones). No generan asiento contable: son sustento documentario y
// seguimiento. Un expediente puede amparar varios `movimientos_caja`.

export type TipoExpediente = 'esquela' | 'carta' | 'orden_pago' | 'resolucion' | 'requerimiento' | 'otro'
export type EstadoExpediente = 'borrador' | 'presentado' | 'en_evaluacion' | 'aceptado' | 'rechazado' | 'desistido'

export interface ExpedienteAdjunto {
  nombre: string
  url: string
  tipo?: string | null
  subido_at?: string | null
}

/** Movimiento de caja amparado por el expediente (resumen que devuelve la API). */
export interface ExpedienteMovimiento {
  id: number
  concepto: string | null
  descripcion: string | null
  monto: number | null
  moneda: string | null
  fecha: string | null
}

export interface ExpedienteSunat {
  id: number
  tipo: TipoExpediente
  numero: string | null
  periodo: string | null          // 'YYYY-MM'
  asunto: string
  estado: EstadoExpediente
  fecha_documento: string | null
  fecha_presentacion: string | null
  fecha_respuesta: string | null
  /** Plazo de respuesta. Alimenta el aviso de vencimiento en la UI. */
  fecha_limite: string | null
  monto_disputado: number | null
  moneda: string
  resultado: string | null
  /** Números de orden citados: formulario 710, PDT 621, órdenes de pago. */
  sustento: Record<string, unknown> | null
  adjuntos: ExpedienteAdjunto[] | null
  notas: string | null
  created_at: string
  movimientos?: ExpedienteMovimiento[]
}

/* ============================================
   Comprobantes de las membresías de Conecta Agenda
   ============================================ */

/**
 * Estados de la cola. El marcado en Agenda cuelga de `enviado`, nunca de `pendiente`:
 * marcarlo antes le mostraría al cliente la serie-número de un documento que no tiene.
 */
export type EstadoAgendaComprobante = 'pendiente' | 'emitido' | 'enviado' | 'descartado'

export interface AgendaOrganizador {
  id: string
  slug: string
  email: string
}

/** Una orden de comprobante en cola. Un cobro aprobado de Agenda que espera su documento. */
export interface AgendaComprobante {
  id: number
  /** uuid del pago en Agenda: la clave de idempotencia de toda la cola. */
  agenda_pago_id: string
  /** id del pago en MercadoPago, para conciliar con el extracto. */
  mp_pago_id: string | null
  plan: string | null
  periodo: string | null                 // mensual | anual
  concepto: string | null
  /** Importe cobrado, IGV incluido. */
  monto: number
  moneda: string
  base_imponible: number | null
  igv: number | null
  cobrado_en: string
  comprobante_tipo: 'boleta' | 'factura'
  doc_tipo: string | null                // DNI | CE | RUC
  doc_numero: string | null
  nombre: string | null
  direccion: string | null
  /** Quien pagó. Puede no ser el dueño de la cuenta: el correo va acá. */
  payer_email: string
  organizador: AgendaOrganizador | null
  estado: EstadoAgendaComprobante
  serie_numero: string | null
  pdf_r2_key: string | null
  pdf_url: string | null
  movimiento_id: number | null
  emitido_at: string | null
  enviado_at: string | null
  marcado_at: string | null
  /** El correo salió pero Agenda no quedó marcada. El cron reintenta solo eso. */
  marcado_error: string | null
  notas: string | null
  created_at: string
  /** Calculado por el backend: días hábiles desde el cobro. Alimenta el aviso de plazo. */
  dias_habiles?: number
}

/** Lo que la IA leyó del PDF subido, antes de confirmar la emisión. */
export interface AgendaComprobanteLectura {
  pdf_r2_key: string
  pdf_url: string
  sugerencia: {
    serie: string | null
    numero: string | null
    serie_numero: string | null
    monto: number | null
    tipo_comprobante: string | null
    confianza: number
  }
  /** Discrepancias contra el cobro: monto, tipo de comprobante, documento. */
  avisos: string[]
}

// ─── Redivia — cobranza de las membresías de la plataforma ───────────────────
//
// El ERP decide qué compró el negocio (plan acordado, cobro, comprobante,
// ingreso); Redivia decide qué funciona (módulos, cupos, suspensión).

export type EstadoRediviaNegocio = 'activo' | 'suspendido' | 'cancelado'
export type EstadoRediviaCobro = 'pendiente' | 'cobrado' | 'anulado'
export type MedioRediviaCobro = 'Transferencia' | 'MercadoPago' | 'Efectivo'

/** Una línea del precio acordado: «Plan Negocio» 390, «WhatsApp PRO» 135. */
export interface RediviaLinea {
  concepto: string
  /** IGV incluido, como todo precio del proyecto. */
  monto: number
}

/**
 * Un plan del catálogo de Redivia. **No es una tabla del ERP**: se lee en vivo
 * desde Redivia (`GET /api/redivia/planes`) y nunca se guarda acá. El ERP
 * guarda solo el precio acordado en `RediviaNegocio`.
 */
export interface RediviaPlan {
  slug: string
  nombre: string
  /** IGV incluido. */
  precio: number
  moneda: string
  descripcion?: string | null
  /** Tramos opcionales que se suman al plan base (canal de WhatsApp). */
  complementos?: RediviaLinea[]
}

/** Lo que devuelve el BFF del catálogo. `disponible:false` ⇒ cargar a mano. */
export interface RediviaCatalogo {
  planes: RediviaPlan[]
  disponible: boolean
  /** Por qué no está disponible, para mostrarlo en el alta. */
  motivo?: string
}

/**
 * El uso real del tenant, leído en vivo desde Redivia. **No se guarda en el
 * ERP**: es estado operativo que cambia todo el tiempo y cuya fuente es el
 * panel. Viene `null` cuando Redivia no contestó.
 */
export interface RediviaUso {
  plan_remoto: string | null
  /** Módulos encendidos: atencion, cobros, senales… */
  modulos: string[]
  clientes_tope: number | null
  clientes_activos: number | null
  /** Ya calculado en el backend: es el número que decide si hay que llamar. */
  clientes_pct: number | null
  usuarios_activos: number | null
  entregas_30d: number | null
  mensajes_30d: number | null
  /** El plan que el uso sugiere. Mayor que el contratado ⇒ upsell. */
  tramo_sugerido: string | null
  /** Su cuenta en el gateway de IA: el puente con el wrapper de Gemini. */
  ia_cuenta_id: string | null
  /**
   * Baja comercial: `false` = dejó de ser cliente. **No es el impago.** Cierra
   * el login sin pantalla de pago y no corta las sesiones ya abiertas.
   */
  activo: boolean | null
  /**
   * Corte por impago: `true` = debe plata. El cliente entra igual, ve el motivo
   * y tiene abierta la página de pago; el pago lo levanta solo.
   */
  suspendido: boolean | null
  suspendido_at: string | null
  /** Lo que el cliente lee en su pantalla de suspensión. */
  suspendido_motivo: string | null
  creado_en: string | null
}

export interface RediviaNegocio {
  id: number
  cliente_id: number
  /** El puente ERP ↔ Redivia. Único: un tenant pertenece a un solo negocio. */
  tenant_slug: string
  plan_slug: string | null
  plan_nombre: string | null
  /** Precio acordado, IGV incluido. `lineas` suma exactamente esto. */
  monto_mensual: number
  moneda: string
  lineas: RediviaLinea[]
  estado: EstadoRediviaNegocio
  /** 1-28, para que el cobro exista en febrero sin reglas de fin de mes. */
  dia_cobro: number
  proximo_cobro: string | null
  provisionado_at: string | null
  suspendido_at: string | null
  notas: string | null
  created_at: string
  updated_at: string
  // Unidos por el backend para el listado.
  cliente_nombre?: string
  cliente_ruc?: string | null
  /** Sin esto no se le puede mandar el comprobante; la pantalla lo avisa. */
  contacto_email?: string | null
  cobros_pendientes?: number
  /** Leído en vivo desde Redivia; `null` si no contestó. */
  uso?: RediviaUso | null
}

export interface RediviaCobro {
  id: number
  negocio_id: number
  /** 'AAAA-MM'. Único por negocio: un cobro por mes. */
  periodo: string
  /** El `cobro_ext_ref` del contrato con Redivia: 'redivia:cobro-<id>'. */
  redivia_cobro_ref: string | null
  lineas: RediviaLinea[]
  /** IGV incluido. `base_imponible` e `igv` se derivan de acá, nunca al revés. */
  monto: number
  base_imponible: number | null
  igv: number | null
  moneda: string
  estado: EstadoRediviaCobro
  medio: MedioRediviaCobro | null
  /** Número de operación de la transferencia o del depósito. */
  referencia: string | null
  pagado_at: string | null
  factura_id: number | null
  movimiento_id: number | null
  avisado_at: string | null
  /** El pago quedó registrado pero Redivia no se enteró. Hay reintento. */
  aviso_error: string | null
  created_at: string
  // Unidos por el backend para el listado.
  negocio_nombre?: string
  tenant_slug?: string
  factura_numero?: string | null
  factura_serie_numero?: string | null
}

/* ─── Buzón de Equipo ───
   Correo propio del ERP sobre team.1conecta.com. No se reusa `Conversacion`
   (WhatsApp: un contacto, sin asunto, sin CC) ni `ProyectoCorreo` (archivo de
   lectura en texto plano). Ver prd/modulos/buzon/01-Buzon-Equipo.md */

export type DireccionBuzon = 'entrante' | 'saliente'
export type EstadoEnvioBuzon = 'enviado' | 'entregado' | 'rebotado' | 'spam' | 'fallido'

/** La identidad con la que sale un correo: una fila por persona del equipo. */
export interface BuzonRemitente {
  id: number
  nombre: string
  apellido: string | null
  /** Lo que el cliente ve en su bandeja. Propio, no derivado de nombre+apellido. */
  nombre_mostrar: string
  email: string
  cargo: string | null
  foto_url: string | null
  foto_r2_key: string | null
  firma_html: string | null
  activo: boolean
  orden: number
  usuario_id: number | null
  created_at: string
  updated_at: string
}

export interface BuzonMensaje {
  id: number
  hilo_id: number
  direccion: DireccionBuzon
  de: string
  para: string[]
  cc: string[]
  asunto: string | null
  cuerpo_texto: string | null
  cuerpo_html: string | null
  /** El Message-ID real. En los salientes lo pone SES, no nosotros. */
  message_id: string
  /** Candado del doble clic al enviar. NULL en los entrantes. */
  envio_id?: string | null
  in_reply_to: string | null
  referencias: string[]
  proveedor_id: string | null
  estado_envio: EstadoEnvioBuzon | null
  adjuntos: { nombre: string; mime: string; size?: number }[]
  fecha: string
  created_at: string
}

export interface BuzonHilo {
  id: number
  asunto: string | null
  participantes: string[]
  remitente_id: number
  cliente_id: number | null
  proyecto_id: number | null
  lead_id: number | null
  no_leidos: number
  ultimo_mensaje_at: string | null
  estado: string
  created_at: string
  updated_at: string
  // Unidos por el backend para el listado; el detalle trae además los mensajes.
  remitente_email?: string
  remitente_nombre?: string
  cantidad?: number
  /** `From` del último mensaje, con nombre para mostrar: encabeza la fila. */
  de_ultimo?: string | null
  /** Para el resumen de la fila sin cargar los cuerpos enteros. */
  resumen?: string | null
  adjuntos?: { nombre: string; mime: string }[]
  mensajes?: BuzonMensaje[]
}
